/* eslint-disable react-hooks/exhaustive-deps */

import "./CalendarPassIntroductionScreen.css";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import curveImage from "../../../assets/images/score-card/curve-image.svg";
import emptyStar from "../../../assets/images/score-card/score-card-empty-star.svg";
import bannerImage from "../../../assets/images/calendar-pass-introduction-banner-image.svg";
import appIcon from "../../../assets/images/header-sabehub-app-icon.svg";
import scalingGraphImage from "../../../assets/gif/scaling-signals.gif";
import { useNavigate, useParams } from "react-router-dom";
import { highlightLastWord } from "utils/utils";
import { useQuery } from "@tanstack/react-query";
import { EXPERIENCE_TYPE } from "utils/constants";
import useWSMApi from "services/api/useWSMApi";
import ROUTE_PATHS from "utils/routePaths";
import { useEffect, useState } from "react";

const CalendarPassIntroductionScreen = () => {
  const navigate = useNavigate();
  const { stage } = useParams();
  const isFourthStage = stage === "4";
  const { fetchEventPassQuestions } = useWSMApi();
  const [selectedSlotData, setSelectedSlotData] = useState<any>(null);

  const { data: passQuestionData, isLoading } = useQuery({
    queryKey: ["get-pass-questions"],
    queryFn: () =>
      fetchEventPassQuestions({
        type: EXPERIENCE_TYPE.FOCUS_HOUSE,
        stage: Number(stage),
      }),
    retry: false,
  });

  useEffect(() => {
    const storedSlotData = localStorage.getItem("selectedSlotData");
    if (storedSlotData) {
      setSelectedSlotData(JSON.parse(storedSlotData));
    }
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleContinue = () => {
    if (!passQuestionData || isLoading) return;
    const questions = passQuestionData?.data?.content ?? [];
    navigate(ROUTE_PATHS.WSM_CALENDAR_PASS_QUESTION_SCREEN, {
      state: {
        questions,
        stage: stage,
        slot_id: selectedSlotData?.id,
        experience_type: selectedSlotData?.experience_type,
      },
    });
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar-pass-introduction-screen-container">
        <div className="calendar-pass-introduction-screen-header-sticky">
          <header className="calendar-pass-introduction-screen-header-bar">
            <img src={appIcon} alt="header-app-icon" />
            <div className="calendar-pass-introduction-screen-header-divider"></div>
            <div className="calendar-pass-introduction-screen-header-right-container">
              <span>{highlightLastWord("The Focus House")}</span>
              <div className="calendar-pass-introduction-screen-header-container">
                <div
                  className="calendar-pass-introduction-screen-header-button"
                  onClick={handleBack}
                >
                  ✕
                </div>
              </div>
            </div>
          </header>
        </div>
        <div className="calendar-pass-introduction-screen-content-container">
          <span className="stage-header-title">Stage - {stage}</span>
          <div className="score-card-matters-decoration" aria-hidden="true">
            <img src={curveImage} alt="" className="score-card-matters-curve" />
            <img src={emptyStar} alt="" className="score-card-matters-star" />
          </div>
          <div className="score-card-matters-card-glow">
            <div className="shadow-card">
              <div className="main-card">
                {isFourthStage ? (
                  <span className="card-header-title">reflection</span>
                ) : (
                  <>
                    <span className="card-header-title">Set Your</span>
                    <span
                      className="card-header-title"
                      style={{ color: "#FF6B35" }}
                    >
                      INTENTION
                    </span>
                  </>
                )}

                {isFourthStage ? (
                  <img
                    src={scalingGraphImage}
                    alt="score-card-image"
                    className="card-gif-image"
                  />
                ) : (
                  <img
                    src={bannerImage}
                    alt="score-card-image"
                    className="card-image"
                  />
                )}

                {isFourthStage ? (
                  <span className="card-title">
                    <span style={{ color: "#FF6B35" }}>Make Your</span> Progress
                    Visible
                  </span>
                ) : (
                  <span className="card-title">
                    <span style={{ color: "#FF6B35" }}>Turn intention</span>{" "}
                    into progress
                  </span>
                )}
                {isFourthStage ? (
                  <div className="card-sub-title">
                    A guided close turns four hours of work into something you
                    can see — What You Moved, How It Felt, & What's Worth
                    Repeating. Two minutes to lock in the learning.
                  </div>
                ) : (
                  <div className="card-sub-title">
                    The Gap between a Busy Day & a Productive one is a clear
                    finish line. In 2 min, turn a crowded to-do list into One
                    Priority — the outcome we'll design your whole session
                    around.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="button-container" onClick={handleContinue}>
            {isFourthStage ? (
              <span>
                Lets Reflect On{" "}
                <span style={{ color: "#FF6B35" }}>Focus Journey</span>
              </span>
            ) : (
              <span>
                Set My <span style={{ color: "#FF6B35" }}>Focus Goal</span>
              </span>
            )}
            <img src={letsDoItIcon} alt="right-arrow-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPassIntroductionScreen;
